var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main d-flex flex-column justify-content-center bg-white"},[_c('section',{attrs:{"id":"brn-locations"}},[_c('GoogleMap',{ref:"map",on:{"ready":_vm.getLocations}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }